import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/packages/gatsby-theme-fuegodocs/src/components/Layout/Layout.js";
import data from "../../docs-data/Tabs.docs.json";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InfoBox = makeShortcode("InfoBox");
const Box = makeShortcode("Box");
const StyledTabsExample = makeShortcode("StyledTabsExample");
const ComponentProps = makeShortcode("ComponentProps");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`A set of layered sections of content—known as tab panels—that are displayed one at a time.`}</p>
    <p>{`Follows the `}<a parentName="p" {...{
        "href": "https://www.w3.org/WAI/ARIA/apg/patterns/tabs/"
      }}>{`WAI-ARIA authoring practices for tabs`}</a>{`.`}</p>
    <h2>{`Import`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { Tabs } from "@fuegokit/react";
`}</code></pre>
    <InfoBox variant="discovery" url={`https://fuegokit.design/react-storybook`} linkText={`explore the examples at Storybook.`} withIcon mdxType="InfoBox">
  Additional styling guides and examples are coming soon. For now,
    </InfoBox>
    <h2>{`Usage`}</h2>
    <Box sx={{
      p: 4,
      border: "1px solid",
      borderRadius: 2,
      borderColor: "border.default"
    }} mdxType="Box">
  <StyledTabsExample mdxType="StyledTabsExample" />
    </Box>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Tabs defaultValue="tab1" orientation="vertical">
  <Tabs.List aria-label="tabs example">
    <Tabs.Trigger value="tab1">One</Tabs.Trigger>
    <Tabs.Trigger value="tab2">Two</Tabs.Trigger>
    <Tabs.Trigger value="tab3">Three</Tabs.Trigger>
  </Tabs.List>
  <Tabs.Content value="tab1">Tab one content</Tabs.Content>
  <Tabs.Content value="tab2">Tab two content</Tabs.Content>
  <Tabs.Content value="tab3">Tab three content</Tabs.Content>
</Tabs>
`}</code></pre>
    <h2>{`Styling`}</h2>
    <p>{`To apply styles to the Tabs primitive, use Fuegokit React's `}<inlineCode parentName="p">{`themeGet`}</inlineCode>{` function to access `}<a parentName="p" {...{
        "href": "https://fuegokit.design/tokens"
      }}>{`Fuegokit Tokens`}</a>{` directly.`}</p>
    <h3>{`Component API`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<StyledTabs defaultValue="tab1" orientation="vertical">
  <StyledTabsList aria-label="tabs example">
    <StyledTabsTrigger value="tab1">One</StyledTabsTrigger>
    <StyledTabsTrigger value="tab2">Two</StyledTabsTrigger>
    <StyledTabsTrigger value="tab3">Three</StyledTabsTrigger>
  </StyledTabsList>
  <StyledTabsContent value="tab1">Tab one content</StyledTabsContent>
  <StyledTabsContent value="tab2">Tab two content</StyledTabsContent>
  <StyledTabsContent value="tab3">Tab three content</StyledTabsContent>
</StyledTabs>
`}</code></pre>
    <h3>{`CSS`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "path=/react/src/Tabs/stories/StoryStyles.tsx src=https://github.com/fuegokit/fuegokit",
        "path": "/react/src/Tabs/stories/StoryStyles.tsx",
        "src": "https://github.com/fuegokit/fuegokit"
      }}>{`const StyledTabs = styled(Tabs)\`
  button,
  fieldset,
  input {
    all: unset;
  }
  display: flex;
  flex-direction: column;
  width: 300px;
  padding: 0px;
  &[role="tablist"] {
    padding: 0px;
  }
\`;
const StyledTabsList = styled(Tabs.List)\`
  flex-shrink: 0;
  /* display: flex; */
  /* border-bottom: 1px solid \${themeGet("colors.border.default")}; */
  box-sizing: border-box;
  appearance: none;
  border: none;
  display: flex;
  padding: 0px;
  position: relative;
  font-weight: \${themeGet("fontWeights.medium")};
  &[role="tablist"] {
    padding: 0px;
  }
  &::before {
    content: "";
    border-radius: 2px;
    bottom: -1px;
    margin: 0px;
    position: absolute;
    width: inherit;
    left: \${themeGet("space.2")};
    right: \${themeGet("space.2")};
    height: 2px;
    background-color: \${themeGet("colors.border.default")};
  }
  &[role="tab"] {
    cursor: pointer;
    line-height: 1.8;
    margin: 0px;
    padding: 4px 8px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
\`;
const StyledTabsTrigger = styled(Tabs.Trigger)\`
  padding: 0.25rem 0.5rem;

  &[role="tab"] {
    font-family: inherit;
    background-color: \${themeGet("colors.elevation.surface.default.[default]")};
    /* padding: \${themeGet("space.1")} \${themeGet("space.2")}; */
    padding: 0.25rem 0.5rem;
    height: \${themeGet("space.5")};
    /* flex: 1; */
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: \${themeGet("fontSizes.3")};
    line-height: 1.8;
    color: \${themeGet("colors.text.default")};
    user-select: none;
    &:first-child {
      border-top-left-radius: 6px;
    }
    &:last-child {
      border-top-right-radius: 6px;
    }
    &:hover {
      color: \${themeGet("colors.text.default")};
    }
    &[data-state="active"] {
      color: \${themeGet("colors.text.selected")};
      box-shadow: inset 0 -1px 0 0 currentColor, 0 1px 0 0 currentColor;
    }
    &:focus {
      position: relative;
      box-shadow: 0 0 0 2px black;
    }
  }
  &[aria-selected="true"] {
    position: relative;
    color: \${themeGet("colors.text.selected")};
    &::after {
      content: "";
      border-radius: 2px;
      bottom: -1px;
      margin: 0px;
      position: absolute;
      width: inherit;
      left: 0;
      right: 0;
      border-bottom: 2px solid \${themeGet("colors.border.selected")};
      height: 0px;
    }
  }
\`;
const StyledTabsContent = styled(Tabs.Content)\`
  flex-grow: 1;
  padding: \${themeGet("space.2")};
  background-color: \${themeGet("colors.elevation.surface.default.[default]")};
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  outline: none;
  &:focus {
    box-shadow: 0 0 0 2px black;
  }
\`;
`}</code></pre>
    <h2>{`Accessibility`}</h2>
    <p>{`Follows the `}<a parentName="p" {...{
        "href": "https://www.w3.org/WAI/ARIA/apg/patterns/tabs/"
      }}>{`WAI-ARIA authoring practices for tabs`}</a>{`.`}</p>
    <h2>{`Keyboard interactions`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Key`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Tab`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`When focus moves onto the tabs, focuses the active trigger. When a trigger is focused, moves focus to the active content.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`ArrowDown`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Moves focus to the next trigger depending on `}<inlineCode parentName="td">{`orientation`}</inlineCode>{` and activates its associated content.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`ArrowRight`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Moves focus to the next trigger depending on `}<inlineCode parentName="td">{`orientation`}</inlineCode>{` and activates its associated content.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`ArrowUp`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Moves focus to the previous trigger depending on `}<inlineCode parentName="td">{`orientation`}</inlineCode>{` and activates its associated content.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`ArrowLeft`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Moves focus to the previous trigger depending on `}<inlineCode parentName="td">{`orientation`}</inlineCode>{` and activates its associated content.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Home`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Moves focus to the first trigger and activates its associated content.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`End`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Moves focus to the last trigger and activates its associated content.`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      